import { ShieldCheck, Award, BadgeCheck, Mail, Phone, User, HardHat } from "lucide-react";
import { Logo } from "./Logo";

const BADGES = [
  { icon: ShieldCheck, title: "HIA", sub: "Housing Industry Association Member", testId: "badge-hia" },
  { icon: Award, title: "Australian Standards", sub: "AS-Compliant Construction", testId: "badge-as" },
  { icon: BadgeCheck, title: "NCC Compliant", sub: "Australian Building Codes Board", testId: "badge-ncc" },
  { icon: HardHat, title: "Lic. 476816C", sub: "NSW Builder Licence", testId: "badge-licence" },
];

const SERVICES = [
  "Residential Homes",
  "Multi-Unit Developments",
  "Childcare Centres",
  "Shop Fit-Outs",
  "Medical Facilities",
  "Knock-Down & Rebuild",
];

export const Footer = () => (
  <footer className="border-t border-white/10 px-6 sm:px-12 lg:px-20 pt-20 pb-10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-16" data-testid="trust-badges">
        {BADGES.map((b) => {
          const Icon = b.icon;
          return (
            <div
              key={b.title}
              data-testid={b.testId}
              className="glass rounded-xl border border-white/10 px-6 py-5 flex items-center gap-4 hover:border-white/25 hover:-translate-y-0.5 transition-all duration-300"
            >
              <span className="w-11 h-11 rounded-full flex items-center justify-center bg-gradient-to-br from-[#FF3D00]/20 to-[#FF1744]/20 border border-[#FF1744]/30 shrink-0">
                <Icon size={20} className="text-[#FF1744]" />
              </span>
              <div>
                <p className="font-display text-sm font-bold text-white">{b.title}</p>
                <p className="text-[11px] text-white/50">{b.sub}</p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-12 border-b border-white/10">
        <div className="lg:col-span-4">
          <Logo width={130} />
          <p className="mt-4 font-serif-lux italic text-lg text-gradient-fire" data-testid="footer-tagline">
            "Where dreams become Reality"
          </p>
          <p className="mt-3 max-w-sm text-xs text-white/50 leading-relaxed">
            Licensed NSW Master Builder crafting residential homes, multi-unit developments,
            childcare centres, shop fit-outs and medical facilities across New South Wales.
          </p>
          <p className="mt-4 font-display text-[11px] font-bold tracking-[0.2em] text-white/60" data-testid="footer-licence">
            NSW BUILDER LICENCE: 476816C
          </p>
        </div>

        <div className="lg:col-span-4" data-testid="footer-contact-card">
          <p className="font-display text-[11px] font-bold tracking-[0.3em] text-[#00E676] mb-5">TALK TO US</p>
          <div className="space-y-4">
            <a href="mailto:admin@jaihomes.com.au" data-testid="footer-email-admin" className="flex items-center gap-3 text-sm text-white/80 hover:text-white transition-colors duration-300">
              <Mail size={16} className="text-[#FF1744] shrink-0" /> admin@jaihomes.com.au
            </a>
            <a href="tel:0272395450" data-testid="footer-phone-landline" className="flex items-center gap-3 text-sm text-white/80 hover:text-white transition-colors duration-300">
              <Phone size={16} className="text-[#FF1744] shrink-0" /> (02) 7239 5450
            </a>
            <a href="tel:0413328202" data-testid="footer-phone-direct" className="flex items-center gap-3 text-sm text-white/80 hover:text-white transition-colors duration-300">
              <Phone size={16} className="text-[#FF1744] shrink-0" /> 0413 328 202
            </a>
            <p className="flex items-center gap-3 text-sm text-white/60" data-testid="footer-contact-person">
              <User size={16} className="text-[#FF1744] shrink-0" /> Surya P — Construction Manager
            </p>
          </div>
        </div>

        <div className="lg:col-span-4" data-testid="footer-services">
          <p className="font-display text-[11px] font-bold tracking-[0.3em] text-[#FFC107] mb-5">WE BUILD</p>
          <div className="flex flex-wrap gap-2">
            {SERVICES.map((s) => (
              <span
                key={s}
                data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 font-display text-xs font-semibold text-white/70 hover:border-[#FFC107]/50 hover:text-white transition-colors duration-300"
              >
                {s}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-[11px] text-white/40">© 2026 JAI HOMES Pty Ltd · NSW Builder Licence 476816C · All rights reserved.</p>
        <a href="/admin" data-testid="footer-admin-link" className="text-[11px] text-white/30 hover:text-white/70 transition-colors duration-300">
          Team Login
        </a>
      </div>
    </div>
  </footer>
);
